export default __webpack_public_path__ + "assets/7d3494865e46c1be914d61dc34c54896.svg";